module.exports = __webpack_public_path__ + "static/media/banner-rimula-mobile.7474afdc.png";